import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  Box,
  Alert,
  AlertIcon,
  Stack,
  useToast
} from "@chakra-ui/react";

const SignupModal = ({ show, onClose }) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const toast = useToast();

  const { signup, loading, error, success } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password1 !== password2) {
      toast({
        title: "Error",
        description: "Passwords do not match!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    await signup(username, email, password1, password2);
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setUsername("");
        setEmail("");
        setPassword1("");
        setPassword2("");
        onClose();
      }, 1500);
    }
  }, [success, onClose]);

  return (
    <Modal isOpen={show} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.600" />
      <ModalContent
        bg="linear-gradient(135deg, rgba(10, 10, 31, 0.95) 0%, rgba(26, 10, 46, 0.95) 100%)"
        borderRadius="2xl"
        border="1px solid"
        borderColor="whiteAlpha.200"
        boxShadow="0 8px 32px rgba(0, 0, 0, 0.4)"
      >
        <ModalHeader
          fontSize="2xl"
          fontWeight="bold"
          bgGradient="linear(to-r, #667eea, #764ba2)"
          bgClip="text"
        >
          Sign Up
        </ModalHeader>
        <ModalCloseButton color="whiteAlpha.800" _hover={{ bg: 'whiteAlpha.200' }} />
        <ModalBody pb={6}>
          <Box as="form" onSubmit={handleSubmit}>
            <Stack spacing={4}>
              {error && (
                <Alert status="error">
                  <AlertIcon />
                  {error}
                </Alert>
              )}
              {success && (
                <Alert status="success">
                  <AlertIcon />
                  Signup successful! Check your email to verify your account.
                </Alert>
              )}
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="whiteAlpha.900">Username</FormLabel>
                <Input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  isDisabled={loading}
                  placeholder="Choose a username"
                  size="md"
                  color="white"
                  bg="whiteAlpha.100"
                  borderColor="purple.500"
                  _placeholder={{ color: "whiteAlpha.500" }}
                  _hover={{ bg: "whiteAlpha.150", borderColor: "purple.400" }}
                  _focus={{ bg: "whiteAlpha.150", borderColor: "purple.300", boxShadow: "0 0 0 1px rgba(102, 126, 234, 0.6)" }}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="whiteAlpha.900">Email</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isDisabled={loading}
                  placeholder="Enter your email"
                  size="md"
                  color="white"
                  bg="whiteAlpha.100"
                  borderColor="purple.500"
                  _placeholder={{ color: "whiteAlpha.500" }}
                  _hover={{ bg: "whiteAlpha.150", borderColor: "purple.400" }}
                  _focus={{ bg: "whiteAlpha.150", borderColor: "purple.300", boxShadow: "0 0 0 1px rgba(102, 126, 234, 0.6)" }}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="whiteAlpha.900">Password</FormLabel>
                <Input
                  type="password"
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                  isDisabled={loading}
                  placeholder="Create a password"
                  size="md"
                  color="white"
                  bg="whiteAlpha.100"
                  borderColor="purple.500"
                  _placeholder={{ color: "whiteAlpha.500" }}
                  _hover={{ bg: "whiteAlpha.150", borderColor: "purple.400" }}
                  _focus={{ bg: "whiteAlpha.150", borderColor: "purple.300", boxShadow: "0 0 0 1px rgba(102, 126, 234, 0.6)" }}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontWeight="medium" color="whiteAlpha.900">Confirm Password</FormLabel>
                <Input
                  type="password"
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  isDisabled={loading}
                  placeholder="Confirm your password"
                  size="md"
                  color="white"
                  bg="whiteAlpha.100"
                  borderColor="purple.500"
                  _placeholder={{ color: "whiteAlpha.500" }}
                  _hover={{ bg: "whiteAlpha.150", borderColor: "purple.400" }}
                  _focus={{ bg: "whiteAlpha.150", borderColor: "purple.300", boxShadow: "0 0 0 1px rgba(102, 126, 234, 0.6)" }}
                />
              </FormControl>
              <Button
                mt={6}
                mb={4}
                bgGradient="linear(to-r, #667eea, #764ba2)"
                _hover={{
                  bgGradient: "linear(to-r, #764ba2, #667eea)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.6)"
                }}
                type="submit"
                isLoading={loading}
                loadingText="Signing up"
                isFullWidth
                size="md"
                fontWeight="bold"
                color="white"
              >
                Sign Up
              </Button>
            </Stack>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SignupModal;
